export default class ObjectUtils {
    static isFunction(obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    }
    
    static findDiffKeys(obj1, obj2) {
        if (!obj1 || !obj2) {
            return {};
        }

        return Object.keys(obj1)
            .filter((key) => !obj2.hasOwnProperty(key))
            .reduce((result, current) => {
                result[current] = obj1[current];

                return result;
            }, {});
    }

    static getJSXElement(obj, ...params) {
        return this.isFunction(obj) ? obj(...params) : obj;
    }

    static setPathFromObject(targetObj, path, sourceObj, defaultValueOrFn) {
        const keys = path.split('.');

        // Obtener valor desde sourceObj usando el path
        let value = sourceObj;
        let found = true;

        for (const key of keys) {
            if (value && typeof value === 'object' && key in value) {
                value = value[key];
            } else {
                found = false;
                break;
            }
        }

        if (!found) {
            value =
            typeof defaultValueOrFn === 'function'
                ? defaultValueOrFn()
                : defaultValueOrFn;
        }

        // Mutar targetObj creando el path si no existe
        let current = targetObj;
        keys.forEach((key, index) => {
            if (index === keys.length - 1) {
                current[key] = value;
            } else {
                if (!current[key] || typeof current[key] !== 'object') {
                    current[key] = {};
                }
                current = current[key];
            }
        });
    }

}